import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import CreditNoteContMain from "presentation/view/container/CreditNote/CreditNoteContMain";

CommonEntrypoint(<CreditNoteContMain/>)